import React, { useContext, useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';
import ServerSideList from '../../../../commonComponents/lists/ServerSideList';
import translate from '../../../../commonComponents/translate';
import {
  BUYER_TYPE,
  compose,
  displayUserName,
  newFormatPrice,
} from '../../../../services/utilityFunctions';
import { formatDate } from '../../../../services/dateUtilityFunctions';
import OpportunitiesListHelper, {
  sendOfferEmail,
} from '../helpers/opportunitiesListHelper';
import withCSRF from '../../../../commonComponents/withCSRF';
import Actions from './Actions';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';

function OpportunitiesListContainer(props) {
  const { t, _csrf, filters } = props;
  const tableId = 'opportunitiesList';
  const tableRef = useRef(null);
  const { loggedUser } = useContext(LoggedUserContext);

  /**
   * Function that initializes with m-datatable
   * allows to update information from within the datatable
   */
  const onInitTable = () => {
    const $opportunityList = $(`#${tableId}`);

    $opportunityList.on('click', '.resend-offer', async function () {
      const opportunityId = $(this).attr('data-opportunity-id');
      await sendOfferEmail(_csrf, [opportunityId]);
    });
  };

  // Init list columns
  const columns = useMemo(() => {
    const columnsData = [];
    const status = {
      pending: {
        title: t('status.negotiation'),
        class: 'status status-pending',
      },
      qualification: {
        title: t('status.qualification'),
        class: 'status status-pending',
      },
      references: {
        title: t('status.references'),
        class: 'status status-pending',
      },
      leads: {
        title: t('status.leads'),
        class: 'status status-pending',
      },
      proposal: {
        title: t('status.proposal'),
        class: 'status status-pending',
      },
      commercial_verification: {
        title: t('status.commercial_verification'),
        class: 'status status-pending',
      },
      waiting_for_encoding: {
        title: t('status.waiting_for_encoding'),
        class: 'status status-pending',
      },
      activation: {
        title: t('status.activation'),
        class: 'status status-pending',
      },
      partially_won: {
        title: t('status.partially_won'),
        class: 'status status-pending',
      },
      approved: {
        title: t('status.opportunity_approved'),
        class: 'status status-approved',
      },
      rejected: {
        title: t('status.opportunity_rejected'),
        class: 'status status-rejected',
      },
      paid: {
        title: t('status.opportunity_paid'),
        class: 'status status-paid',
      },
      pending_payment: {
        title: t('shop.pending_payment'),
        class: 'status status-pending_payment',
      },
    };
    const handleCells = (value, className) =>
      renderToStaticMarkup(
        <span className={`opportunity-cell ${className || ''}`}>{value}</span>,
      );

    if (filters.buyerType !== BUYER_TYPE.OWNER) {
      columnsData.push({
        field: 'owner',
        title: t('user_type_customer'),
        textAlign: 'left',
        sortable: false,
        width: 150,
        template: ({ owner }) => handleCells(displayUserName(owner)),
      });
    }
    columnsData.push(
      {
        field: 'name',
        title: t('name'),
        textAlign: 'left',
        width: 150,
        template: ({ name }) => handleCells(name),
      },
      {
        field: 'number',
        title: t('number'),
        textAlign: 'left',
        width: 150,
        template: ({ number }) => handleCells(number),
      },
      {
        field: 'date',
        title: t('date'),
        textAlign: 'left',
        width: 150,
        template: ({ createdAt }) =>
          handleCells(formatDate(createdAt, 'DD MMM, YYYY')),
      },
      {
        field: 'price',
        title: t('price'),
        textAlign: 'left',
        width: 150,
        template: ({ total, currency }) =>
          handleCells(newFormatPrice(total, true, currency)),
      },
      {
        field: 'status',
        title: t('status'),
        textAlign: 'left',
        width: 150,
        template: opportunity =>
          handleCells(
            status[opportunity.status].title,
            status[opportunity.status].class,
          ),
      },
    );
    columnsData.push({
      field: 'actions',
      width: 60,
      textAlign: 'center',
      title: t('actions'),
      sortable: false,
      overflow: 'visible',
      template: opportunity =>
        renderToStaticMarkup(
          <Actions
            t={t}
            opportunity={opportunity}
            loggedUserId={loggedUser?._id}
          />,
        ),
    });
    return columnsData;
  }, [filters?.buyerType]);

  useEffect(() => {
    if (tableRef?.current) {
      tableRef.current.destroy();
      // wait for table to be destroyed
      setTimeout(() => tableRef.current.mountTable(), 300);
    }
  }, [filters?.buyerType]);

  return (
    <div className="opportunities-list-wrapper">
      <ServerSideList
        id={tableId}
        ref={tableRef}
        dataSourceURL="/table/market/opportunity/list"
        dataSourceParams={{
          populate: ['owner'],
          sort: '-createdAt',
        }}
        query={filters}
        columns={columns}
        // onRowClick={item => {
        //   if (item) {
        //     window.location = `/shop/opportunity/${item._id}`;
        //   }
        // }}
        onInit={onInitTable}
      />
    </div>
  );
}

OpportunitiesListContainer.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  filters: PropTypes.shape(OpportunitiesListHelper.propType),
};

OpportunitiesListContainer.defaultProps = {
  filters: OpportunitiesListHelper.defaultProp,
};

export default compose(withCSRF, translate)(OpportunitiesListContainer);
